import React from "react";
import { LogoCenter } from "../../component/LogoCenter";
import arrowNext from "../../images/arrowNext.svg";
import { Link } from "react-router-dom";
export const SignUpInfo = () => {
  return (
    <div className={`p-[20px] bg-black h-dvh overflow-hidden `}>
      <div className="w-full max-w-2xl mx-auto h-full flex flex-col justify-between items-center  overflow-y-auto">
        <LogoCenter />
        <div className="flex flex-col gap-[50px] w-full">
          <div className="flex flex-col gap-[15px]">
            <h1 className="text-white text-[40px] leading-[95%] font-light uppercase">
              you&apos;re in <br /> get started
            </h1>
            <form action="" className="flex flex-col gap-[15px]">
              <input
                type="text"
                className="border border-white focus:outline-none rounded-[50px] bg-transparent text-white text-lg !leading-none p-[16px] font-normal placeholder:text-[#5d5d5d]"
                placeholder="First Name"
              />
              <input
                type="text"
                className="border border-white focus:outline-none rounded-[50px] bg-transparent text-white text-lg !leading-none p-[16px] font-normal placeholder:text-[#5d5d5d]"
                placeholder="Last Name"
              />
              <input
                type="tel"
                className="border border-white focus:outline-none rounded-[50px] bg-transparent text-white text-lg !leading-none p-[16px] font-normal placeholder:text-[#5d5d5d]"
                placeholder="Phone Number"
              />
            </form>
          </div>
          <Link to="/signuplogininfo" className="bg-white size-[70px] rounded-full flex justify-center items-center hover:bg-white/50 transition-all duration-300 ml-auto">
            <img src={arrowNext} alt="arrow" className="object-contain" />
          </Link>
        </div>
      </div>
    </div>
  );
};
